import { Document } from '../types/document';
import { Evidence } from '../types/evidence';
import {
  TaskData,
  TaskDataWithNotes,
  TStatefulIconStates,
} from '../types/task';
import { TaskTypes } from '../types/taskTypes';

export const HELD_ERROR = 'Error - Verify Drivers License';

export enum EvidenceStateInfo {
  TIMED_OUT = 'TIMED_OUT',
  HELD = 'HELD',
  PARSING_ERROR = 'PARSING_ERROR',
  DATA_FAILURE = 'DATA_FAILURE',
}

/**
 * Maintains status of any uploads
 * for this task - keyed by document type
 */
export interface TaskUploadStatus {
  [documentType: string]: boolean;
}

export interface ITask {
  id: number;
  taskType: TaskTypes;
  taskData: TaskData;
  state: TStatefulIconStates;
  outdated: boolean;
  sufficient?: boolean;
  feedback?: string;
  isActive?: boolean;
  retriedAt: string;
  evidence?: Evidence;
  attachment?: Document;
  attachments?: Document[];
  evidenceStateInfo?: EvidenceStateInfo;
  ongoingUpload?: TaskUploadStatus;
  createdAt?: string;
  evidenceId?: number;
  waiveReason?: string | null;
  updatedAt?: string;
}

export interface ITaskWithNotes {
  id: number;
  taskType: TaskTypes;
  taskData: TaskDataWithNotes;
  state: TStatefulIconStates;
  outdated: boolean;
  sufficient?: boolean;
  feedback?: string;
  isActive?: boolean;
  retriedAt: string;
  createdAt: string;
  evidence?: Evidence;
  attachment?: Document;
  attachments?: Document[];
  evidenceStateInfo?: EvidenceStateInfo;
  ongoingUpload?: TaskUploadStatus;
  waiveReason?: string | null;
}
